import React, { useRef, useState } from "react";

const ZOOM = 3;        // zoom level (increase for more magnification)
const PANE_W = 600;    // zoom pane width in px
const PANE_H = 420;    // zoom pane height in px

const MyReactImageMagnify = ({ image }) => {
  const imgRef = useRef(null);
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0, w: 0, h: 0 });

  const lensW = PANE_W / ZOOM;
  const lensH = PANE_H / ZOOM;

  const handleMove = (e) => {
    const rect = imgRef.current.getBoundingClientRect();

    // keep lens centered on cursor, but inside the image
    let x = e.clientX - rect.left - lensW / 2;
    let y = e.clientY - rect.top - lensH / 2;
    x = Math.max(0, Math.min(x, rect.width - lensW));
    y = Math.max(0, Math.min(y, rect.height - lensH));

    setPos({ x, y, w: rect.width, h: rect.height });
  };

  return (
    <div className="magnify_wrapper">
      <div
        className="magnify_box"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onMouseMove={handleMove}
      >
        <img ref={imgRef} src={image} alt="product" draggable={false} />

        {show && (
          <div
            className="magnify_lens"
            style={{
              width: lensW,
              height: lensH,
              transform: `translate(${pos.x}px, ${pos.y}px)`,
            }}
          />
        )}
      </div>

      {show && (
        <div
          className="magnify_pane"
          style={{
            width: PANE_W,
            height: PANE_H,
            backgroundImage: `url(${image})`,
            backgroundSize: `${pos.w * ZOOM}px ${pos.h * ZOOM}px`,
            backgroundPosition: `-${pos.x * ZOOM}px -${pos.y * ZOOM}px`,
          }}
        />
      )}
    </div>
  );
};

export default MyReactImageMagnify;